export const DropboxIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M6 0L0 4l6 4 6-4zM18 0l-6 4 6 4 6-4zM0 12l6 4 6-4-6-4zM18 8l-6 4 6 4 6-4zM12 16L6 20l6 4 6-4z"
      fill="#0061FF"
    />
  </svg>
);
